import 'sass/blocks/_search-for-profession-with-help.scss';

import React from 'react';
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
import { SelectList } from 'components/SelectList/SelectList';
import { CREDIT_CARD } from 'constants/userProfile';
import { CIRBE } from 'constants/identityMethod';
import { InfoTooltip } from 'components/tooltip/tooltip';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import BlockWrapper from 'components/blockWrapper/blockWrapper';
import { InputText } from 'components/inputText/inputText';
import { RadioButton } from 'components/RadioButton/RadioButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import CheckBox from 'components/checkBox/checkBox';
import { isNumeric } from 'validator';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { LOAN } from 'constants/userProfile';

const TRUE_RADIO = '1';
const FALSE_RADIO = '2';

const AnnualIncome = ({ userProfile, disabled, model, optionsList, handleSave, onChange, ...props }) => {
    const {
        formActions: { change, resetValidity },
        flags,
    } = props;
    const { investmentType } = userProfile;
    const annualIncomeAmount = userProfile[`${model}_annualIncomeAmount`];

    const userActiveInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

    return (
        <div>
            <ConditionalToggling condition={flags.get(CIRBE) && userActiveInvestmentType[CREDIT_CARD]}>
                <label>
                    <span>{formatText('annualIncomeStatement-annualIncomeTitle')}</span>
                </label>
            </ConditionalToggling>

            <BlockWrapper position={0} visible={true}>
                <div className="annual-income-text">
                    <label>
                        {formatText('field-annualIncomeStatement')}
                        <ConditionalToggling condition={userActiveInvestmentType[CREDIT_CARD]}>
                            <InfoTooltip text={<FormattedText value="field-annualIncomeStatementTooltip" />} />
                        </ConditionalToggling>
                    </label>
                    <br />
                    {userActiveInvestmentType[LOAN] && (
                        <React.Fragment>
                            <span>{formatText('annualIncomeStatement-selectAnnualIncomeDescription_ares')}</span> <br />
                        </React.Fragment>
                    )}

                    <ConditionalToggling condition={userActiveInvestmentType[CREDIT_CARD]}>
                        <span>{formatText('annualIncomeStatement-selectAnnualIncomeDescriptionCreditCard')}</span>
                    </ConditionalToggling>
                    <SelectList
                        profileModel={`userProfile.${model}_annualIncomeAmount`}
                        name={`${model}_annualIncomeAmount`}
                        optionsList={optionsList.annualIncomeAmount}
                        clearable={false}
                        searchable={false}
                        required
                        onChange={function (value) {
                            if (onChange) onChange(value);
                            handleSave('annualIncomeAmount', value);
                        }}
                        focusAnimated
                        disabled={disabled}
                        placeholder={formatText('field-annualIncomeStatementPlaceholder')}
                        validations={{
                            required: () => annualIncomeAmount && annualIncomeAmount.length,
                        }}
                        userProfile={userProfile}
                        {...props}
                    />
                </div>
            </BlockWrapper>

            <FeatureTogglingRender notAllowedProductKey={CIRBE}>
                <ConditionalToggling condition={userActiveInvestmentType[CREDIT_CARD]}>
                    <BlockWrapper position={1} visible={true} firstValue={userProfile.monthlyAmount}>
                        <div className="annual-income-text search-wrapper">
                            <label>{formatText('field-annualMonthlyAmountToltip')}</label>
                            <br />
                            <span>{formatText('field-annualMonthlyAmountStatement')}</span>
                            <div className="search-inputText">
                                <InputText
                                    profileModel={`userProfile.monthlyAmount`}
                                    validations={{
                                        required: value => value && value.length,
                                        valid: value => value && value.length >= 0 && isNumeric(value),
                                    }}
                                    // isValidated={function () {
                                    //     handleSave(`monthlyAmount`, userProfile[`monthlyAmount`]);
                                    // }}
                                    messagesError={{
                                        valid: formatText('validation-notValidAnnualIncomeStatement'),
                                        required: formatText('validation-annualIncomeStatementRequired'),
                                    }}
                                    focusAnimated
                                    {...props}
                                />
                            </div>
                        </div>
                    </BlockWrapper>

                    <BlockWrapper position={2} visible={true}>
                        <div className="annual-income-text search-wrapper">
                            <RadioButton
                                profileModel={`userProfile.monthlyRenting`}
                                label={formatText('field-monthlyRentQuestion')}
                                optionsList={optionsList.monthlyQuestions}
                                isUpdated={() => {
                                    const VALIDATED_ACTIONS = {
                                        [TRUE_RADIO]: () => change('userProfile.monthlyRenting', TRUE_RADIO),
                                        [FALSE_RADIO]: () => {
                                            change('userProfile.monthlyRenting', FALSE_RADIO);
                                            change('userProfile.monthlyRentingAmount', null);
                                            resetValidity('userProfile.monthlyRentingAmount');
                                            // handleSave('monthlyRenting', { answered: false, amount: '0' });
                                        },
                                    };

                                    VALIDATED_ACTIONS[userProfile.monthlyRenting]();
                                }}
                                userProfile={userProfile}
                                focusAnimated
                                {...props}
                            />
                        </div>
                    </BlockWrapper>

                    <ConditionalToggling condition={userProfile.monthlyRenting === TRUE_RADIO}>
                        <label className="search-inputText">{formatText('field-monthlyRentQuestionAmount')}</label>
                        <br />
                        <InputText
                            profileModel={`userProfile.monthlyRentingAmount`}
                            validations={{
                                required: value => value && value.length,
                                valid: value => value && value.length >= 0 && isNumeric(value),
                            }}
                            // isValidated={function () {
                            //     handleSave('monthlyRenting', { answered: true, amount: userProfile.monthlyRentingAmount });
                            // }}
                            messagesError={{
                                valid: formatText('validation-notValidAnnualIncomeStatement', [0, 60]),
                                required: formatText('validation-annualIncomeStatementRequired'),
                            }}
                            focusAnimated
                            {...props}
                        />
                    </ConditionalToggling>

                    <BlockWrapper position={4} visible={true}>
                        <div className="annual-income-text search-wrapper">
                            <RadioButton
                                profileModel="userProfile.monthlyMortgage"
                                label={formatText('field-monthlyMortgagePayQuestion')}
                                optionsList={optionsList.monthlyQuestions}
                                isUpdated={() => {
                                    const VALIDATED_ACTIONS = {
                                        [TRUE_RADIO]: () => change('userProfile.monthlyMortgage', TRUE_RADIO),
                                        [FALSE_RADIO]: () => {
                                            change('userProfile.monthlyMortgage', FALSE_RADIO);
                                            change('userProfile.monthlyMortgageAmount', null);
                                            resetValidity('userProfile.monthlyMortgageAmount');
                                            // handleSave('monthlyMortgage', { answered: false, amount: '0' });
                                        },
                                    };

                                    VALIDATED_ACTIONS[userProfile.monthlyMortgage]();
                                }}
                                userProfile={userProfile}
                                disabled={disabled}
                                focusAnimated
                                {...props}
                            />
                        </div>
                    </BlockWrapper>

                    <ConditionalToggling condition={userProfile.monthlyMortgage === TRUE_RADIO}>
                        <label className="search-inputText">{formatText('field-monthlyMortgageQuestionAmount')}</label>
                        <br />
                        <InputText
                            profileModel="userProfile.monthlyMortgageAmount"
                            validations={{
                                required: value => value && value.length,
                                valid: value => value && value.length >= 0 && isNumeric(value),
                            }}
                            // isValidated={function () {
                            //     handleSave('monthlyMortgage', { answered: true, amount: userProfile.monthlyMortgageAmount });
                            // }}
                            messagesError={{
                                valid: formatText('validation-notValidAnnualIncomeStatement'),
                                required: formatText('validation-annualIncomeStatementRequired'),
                            }}
                            focusAnimated
                            {...props}
                        />
                    </ConditionalToggling>

                    <BlockWrapper position={5} visible={true}>
                        <div className="annual-income-text search-wrapper">
                            <RadioButton
                                profileModel="userProfile.monthlyLoan"
                                label={formatText('field-monthlyPaymentDebtQuestion')}
                                optionsList={optionsList.monthlyQuestions}
                                isUpdated={() => {
                                    const VALIDATED_ACTIONS = {
                                        [TRUE_RADIO]: () => change('userProfile.monthlyLoan', TRUE_RADIO),
                                        [FALSE_RADIO]: () => {
                                            change('userProfile.monthlyLoan', FALSE_RADIO);
                                            change('userProfile.monthlyLoanAmount', null);
                                            resetValidity('userProfile.monthlyLoanAmount');
                                            // handleSave('monthlyLoan', { answered: false, amount: '0' });
                                        },
                                    };

                                    VALIDATED_ACTIONS[userProfile.monthlyLoan]();
                                }}
                                userProfile={userProfile}
                                disabled={disabled}
                                focusAnimated
                                {...props}
                            />
                        </div>
                    </BlockWrapper>

                    <ConditionalToggling condition={userProfile.monthlyLoan === TRUE_RADIO}>
                        <label className="search-inputText">{formatText('field-monthlyDebtQuestionAmount')}</label>
                        <br />
                        <InputText
                            profileModel="userProfile.monthlyLoanAmount"
                            validations={{
                                required: value => value && value.length,
                                valid: value => value && value.length >= 0,
                            }}
                            // isValidated={function () {
                            //     handleSave('monthlyLoan', { answered: true, amount: userProfile.monthlyLoanAmount });
                            // }}
                            messagesError={{
                                valid: formatText('validation-notValidAnnualIncomeStatement'),
                                required: formatText('validation-annualIncomeStatementRequired'),
                            }}
                            focusAnimated
                            {...props}
                        />
                    </ConditionalToggling>

                    <ConditionalToggling condition={userProfile.monthlyLoan}>
                        <div className="legal-checkbox">
                            <CheckBox
                                profileModel="userProfile.cirbeConsent"
                                fieldsRequired="1"
                                checkBoxList={[
                                    {
                                        label: formatText('field-cirbeConsent'),
                                        model: 'userProfile.cirbeConsentCheck',
                                        required: true,
                                        onChange: () => {
                                            change('userProfile.cirbeConsent', formatText('field-cirbeConsent'));
                                        },
                                    },
                                ]}
                                userProfile={userProfile}
                                {...props}
                                messagesError={{
                                    required: formatText('validation-fieldRequiredDataProtectionClause'),
                                }}
                            />
                        </div>
                    </ConditionalToggling>
                </ConditionalToggling>
            </FeatureTogglingRender>
        </div>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        cardImages: state.cardImages,
    }),
    dispatch => ({
        formActions: bindActionCreators(actions, dispatch),
    })
)(withFeatureToggling(AnnualIncome));